export const ListQueryKey = 'projectAutoTransRecords';
export const DetailQueryKey = 'projectAutoTransRecord';
export const Urls = {
  selectUrl: '/AutoTransRecord/list',
  updateUrl: '/AutoTransRecord/update',
  deleteUrl: '/AutoTransRecord/delete',
  createUrl: '/AutoTransRecord/create',
  detailUrl: '/AutoTransRecord/info'
};